import React from 'react'
import { Draggable } from 'react-beautiful-dnd'

export function Images({ images, project }) {
  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          display: 'grid',
          // MAGIC LINE: Adjust '120px' to control when it breaks to the next line.
          // Larger number (e.g., 150px) = fewer columns, bigger images.
          // Smaller number (e.g., 100px) = more columns, smaller images.
          gridTemplateColumns: 'repeat(auto-fill, minmax(60px, 1fr))',
          gap: 'clamp(3px, 1vw, 5px)', // Space between images
          width: '100%',
          boxSizing: 'border-box'
        }}
      >
        {images.map((image, i) => (
          <div key={i} style={{ minWidth: 0 }}>
             {/* minWidth: 0 prevents grid blowout issues */}
            <Draggable key={i} draggableId={`${project.id}prefix${image.name}`} index={i}>
              {(provided) => (
                <div
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                  style={{
                    ...provided.draggableProps.style,
                    // Force square aspect ratio
                    aspectRatio: '1 / 1',
                    position: 'relative',
                    overflow: 'hidden',
                    borderRadius: '1px',
                    border: '1px solid #eee' 
                  }}
                >
                  <img
                    className="full-width"
                    style={{
                      border: image.marked ? `2px solid yellow` : `none`,
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover', // Ensures image fills the square perfectly
                      display: 'block'
                    }}
                    src={image?.thumbnail?.url ? image.thumbnail.url : image.url}
                    alt="intake"
                    data-cy="images"
                  />
                </div>
              )}
            </Draggable>
          </div>
        ))}
      </div>
    </div>
  )
}